import httpClient from "../axiosBase/axiosHandler";

export const createExpense = (data) => {
  return httpClient.post("expenses/", data);
};

export const updateExpense = ({ id, data }) => {
  return httpClient.put(`expenses/${id}/`, data);
};

export const createBulkExpense = (data) => {
  return httpClient.post("expenses/create-bulk-expense/", data);
};

export const getExpenses = (queries) => {
  return httpClient.get(`expenses/${queries}`);
};

export const createExpenseCategory = (data) => {
  return httpClient.post("expenses-categories/", data);
};

export const editExpenseCategory = ({ data, id }) => {
  return httpClient.put(`expenses-categories/${id}/`, data);
};

export const deleteExpenseCategory = ({ id }) => {
  return httpClient.delete(`expenses-categories/${id}/`);
};

export const getExpenseCategories = () => {
  return httpClient.get("expenses-categories/");
};

export const getVideos = () => {
  return httpClient.get("tutorials/");
};

export const getExpenseDetails = (id) => {
  return httpClient.get(`expenses/${id}/`);
};

export const approveOrRejectExpenseWithoutDisbursement = ({
  status,
  data,
  id,
}) => {
  return httpClient.patch(`expenses/${id}/${status}/`, data);
};

export const disburseExpenseFunds = ({ data, id }) => {
  return httpClient.patch(`expenses/${id}/disburse/`, data);
};

export const getExpenseAnalytics = (queries) => {
  return httpClient.get(`expenses-analytics/analytics-data/${queries}`);
};

export const updateExpenseCategory = ({ expenseId, categoryId }) => {
  return httpClient.patch(`expenses/${expenseId}/update-expense-category/`, {
    category_id: categoryId,
  });
};

export const makeRefundStatusUpdate = ({ data, id }) => {
  return httpClient.patch(`expenses/${id}/make-refund/`, data);
};

export const cancelExpenseRecurrence = (id) => {
  return httpClient.patch(`expenses/${id}/cancel-recurrence/`);
};

export const getExpenseDepartments = (queries) => {
  return httpClient.get(`departments/${queries}`, {
    params: { per_page: 50 },
  });
};

export const createExpenseDepartment = (data) => {
  return httpClient.post("departments/", data);
};

export const updateExpenseDepartment = ({ data, id }) => {
  return httpClient.patch(`departments/${id}/`, data);
};

export const deleteExpenseDepartment = ({ id }) => {
  return httpClient.delete(`departments/${id}/`);
};

export const getExpenseDepartmentDetails = ({ id }) => {
  return httpClient.get(`/departments/${id}/`);
};
